import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

type Props = {
  className?: string;
};

export const ClientReviewLabel: FC<Props> = ({ className }) => (
  <span
    className={`
    ${styles.label}
    ${className || ""}
  `}
  >
    <span className={styles.iconOuter}>
      <Icon name="message" />
    </span>
    口コミあり
  </span>
);
